import { render } from "./CookieComplySwitch.vue?vue&type=template&id=52efa5f2"
import script from "./CookieComplySwitch.vue?vue&type=script&lang=js"
export * from "./CookieComplySwitch.vue?vue&type=script&lang=js"

import "./CookieComplySwitch.vue?vue&type=style&index=0&id=52efa5f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__